/* Novéa — Swap de l'image de la carte au clic sur une pastille de couleur (page collection). */
(function () {
  'use strict';
  document.addEventListener('change', function (e) {
    var input = e.target.closest('.color-swatch input');
    if (!input) return;
    var card = input.closest('.card-wrapper, .product-card-wrapper');
    var swatch = input.closest('.color-swatch');
    if (!card || !swatch) return;
    var media = swatch.getAttribute('data-nv-swatch-media');
    if (!media) return;
    var img = card.querySelector('.card__media img');
    if (!img) return;
    // mémoriser l'image d'origine une seule fois
    if (!img.dataset.nvOriginalSrc) {
      img.dataset.nvOriginalSrc = img.currentSrc || img.src;
      img.dataset.nvOriginalSrcset = img.getAttribute('srcset') || '';
    }
    img.setAttribute('srcset', '');
    img.src = media;
  });
})();
